
import { fetchJSON, buildURL, postImage } from './fetch_utils';

/* global __API_BASE_URL__ */
let siteBaseUrl = __API_BASE_URL__;
let apiUrl = siteBaseUrl + "/api.php";
let adminApiUrl = siteBaseUrl + "/admin/admin.php";

// const simulateDelay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export let proposals_request = async () => {
    const url = buildURL(adminApiUrl, { proposals: '' });
    return await fetchJSON(url, {
        method: 'GET',
        credentials: 'include'
    });
};

export let proposal_request = async (id) => {
    const url = buildURL(adminApiUrl, { proposal: id });
    return await fetchJSON(url, {
        method: 'GET',
        credentials: 'include'
    });
};
  
export let commit_request = async (changeset, proposal) => {
    const url = buildURL(adminApiUrl, { commit: '' });
    return await fetchJSON(url, {
        method: 'POST',
        body: JSON.stringify({ changeset, proposal }),
        credentials: 'include',
    });
};
  
export let propose_request = async (changeset, fromEmail, comment) => {
    const url = buildURL(apiUrl, { propose: '' });
    return await fetchJSON(url, {
        method: 'POST',
        body: JSON.stringify({ changeset, fromEmail, comment }),
    });
};

export let reject_proposal_request = async (id) => {
    const url = buildURL(adminApiUrl, { reject_proposal: '' });
    return await fetchJSON(url, {
        method: 'POST',
        body: JSON.stringify({ id }),
        credentials: 'include',
    });
};
  
export let graph_data_request = async () => {
    const url = buildURL(apiUrl, { graph_data: '' });
    let ret = await fetchJSON(url); 
    //ret.map((node) => {
    // Loop through object keys and correct the image URL
    Object.keys(ret.nodes).forEach((key) => {
        let node = ret.nodes[key];
        node.imageUrl = image_url(node.imageId);
    });
    return ret;
};

export let button_posts_request = async () => {
    const url = buildURL(apiUrl, { button_posts: '' });
    let ret = await fetchJSON(url);
    ret.forEach((post) => {
        post.imageUrl = image_url(post.imageId);
        if (post.action === 'Image') {
            post.actionParameterImage = image_url(post.actionParameter * 1);
        }
    });
    return ret;
};

export let add_button_post_request = async (buttonPost) => {
    // NOTE: If buttonPost has an id, it will be updated; otherwise, a new button post will be created
    const url = buildURL(adminApiUrl, { button_post: '' });
    return await fetchJSON(url, {
        method: 'POST',
        body: JSON.stringify(buttonPost),
        credentials: 'include',
    }); // { status: true } || { status: true, new_button_post_id: 123 } || { status: false, error: 'Error message' }
};

export let update_button_post_request = async (buttonPostId, buttonPost) => {
    // NOTE: If buttonPost has an id, it will be updated; otherwise, a new button post will be created
    const url = buildURL(adminApiUrl, { button_post: buttonPostId });
    return await fetchJSON(url, {
        method: 'POST',
        body: JSON.stringify(buttonPost),
        credentials: 'include',
    }); // { status: true } || { status: true, new_button_post_id: 123 } || { status: false, error: 'Error message' }
};

export let delete_button_post_request = async (buttonPostId) => {
    const url = buildURL(adminApiUrl, { delete_button_post: buttonPostId });
    return await fetchJSON(url, {
        method: 'GET',
        credentials: 'include',
    }); // { status: true } || { status: false, error: 'Error message' }
};

export let upload_image_request = async (file, extraFields) => {
    const url = buildURL(adminApiUrl, { upload_image: '' });
    return await postImage(url, file, extraFields); // { status: true, image_id: 123 } || { status: false, error: 'Error message' }
}

export let image_url = (imageId) => {
    if (!imageId) return;
    return siteBaseUrl + `/image.php?id=${imageId}`;
};

export default {
    graph_data_request,
    propose_request,
    button_posts_request,
    
    reject_proposal_request,
    commit_request,
    proposals_request,
    proposal_request,
    add_button_post_request,
    update_button_post_request,
    delete_button_post_request,
    upload_image_request,

    image_url,
};